<template>
    <modal name="modal-product-offline"
           class="dd-m-modal dd-m-modal--product-list">

        <main class="dd-l-container dd-l-container--product">
            <div class="dd-l-container__wrapper">
                <div class="dd-l-container__content dd-l-container--product__container">

                    <section class="dd-l-section--product">
                        <card-product-info-offline
                                v-if="product"
                                :hide="hide"
                                :item="product"></card-product-info-offline>

                        <div v-else>
                            <h1 class="dd-l-section--product__title">
                                Product not found
                            </h1>

                            <button class="dd-m-button dd-m-button--assertive dd-m-button--sm"
                                    @click.prevent="hide">
                                Back
                            </button>
                        </div>
                    </section>
                </div>
            </div>
        </main>

    </modal>
</template>
<script>
    import CardProductInfoOffline from '../../components/products/card-product-info-offline';

    export default {
        name: 'modal-product-offline',
        components: {CardProductInfoOffline},
        data: () => {
            return {
                product: []
            }
        },
        mounted() {
            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('showOfflineProduct', (msg, param) => {
                    this.product = param;
                    this.show();
                });

                PubSub.subscribe('hideOfflineProduct', () => this.hide());
            },
            show() {
                this.$modal.show('modal-product-offline');
            },
            hide() {
                this.$modal.hide('modal-product-offline');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/custom-modals/modal-product-offline.vue